import { Component } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-flight-detail-dialog',
    imports: [],
    templateUrl: './flight-detail-dialog.component.html',
    styleUrl: './flight-detail-dialog.component.scss'
})
export class FlightDetailDialogComponent {

  
  dataItem?: string;

  constructor(
    private config: DynamicDialogConfig
  ) { }

  ngOnInit(): void {
    const id = this.config.data;
    if (id === 0) {
      this.loadFlightDetailsInfo();
    }
    else if (id === 1) {
      this.loadFlightTimesInfo();
    }
    else {
      this.loadCalendarInfo();
    }
  }

  loadFlightDetailsInfo() {
    this.dataItem = `Occasionally, there may be discrepancies or missing information, 
    like aircraft type, nose number, or crew details, due to a lack in data.  
    For flight number 0, AA sometimes designates it as a Surface Duty/Miscellaneous 
    deadhead flight, like surface transportation between stations.`
  }

  loadFlightTimesInfo() {
    this.dataItem = `Block times are arranaged as Scheduled, Rescheduled and Actual.  The 
    times arrangement are based on user preferences of either Local(UTC) or UTC(Local).  If
    actual times are displaying 'Out' and 'In' 0:00 or not at all, this typically indicate that 
    a flight was recorded as a deadhead flight with an 'Other Airline' or as a 'Surface 
    Duty/Miscellaneous' such as ground transportation.`
  }

  loadCalendarInfo() {
    this.dataItem = `The calendar view presents the current month and year selected. Any 
    modifications to the calendar month and year will automatically synchronize with the 
    Table View. To navigate the month and year, utilize the preceding (<) and subsequent (>) 
    buttons for the month, and the preceding (<<) and subsequent (>>) buttons for the year.  
    The calendar will display the completed flight sequences for the contractual month.  
    Additionally, the user can select a specific sequence to view the comprehensive details of the entire sequence.`
  }
}
